<template>
  <div class="rtd_content">
    <div class="rtd_head">
      <div class="rtd_back" @click="getBack()">返回</div>
      <div class="rtd_title">外包任务</div>
    </div>

    <van-pull-refresh
      v-model="tempRefresh"
      success-text="刷新成功"
      @refresh="tempOnRefresh"
    >
      <van-list
        ref="list"
        class=""
        v-model="tempLoading"
        :finished="tempFinished"
        :finished-text="'暂无更多任务~'"
        @load="tempOnLoad"
      >
        <ul class="temp_body">
          <li
            v-for="(item, index) in tempList"
            :key="index"
            class="temp_li"
            @click="tempDetail(item)"
          >
            <div class="temp_title_salary">
              <div class="temp_title">{{ item.Title }}</div>
              <div class="temp_salary">{{ item.Salary }}</div>
            </div>
            <div class="temp_titleDesc">{{ item.Description }}</div>
            <div class="temp_status_timeDesc">
              <div :class="filterColor[item.Status]">
                {{ item.Status | filterStatus }}
              </div>
              <div class="temp_timeDesc">{{ item.TimeDesc }} 发布</div>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from "vue";
import { getTempList } from "@/config/api.js";
import { PullRefresh, List } from "vant";
export default {
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      tempList: [], //  外包任务
      filterColor: {
        0: "temp_status5",
        1: "temp_status1",
        2: "temp_status5",
        3: "temp_status5",
        4: "temp_status5",
        5: "temp_status5",
      },
      tempLoading: false,
      tempFinished: false,
      tempRefresh: false,

      page: 1,
      totalPage: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.refresh === "1") {
        vm.tempOnRefresh();
      }
    });
  },
  methods: {
    // 返回上一页
    getBack() {
      var that = this;
      that.$router.push({
        path: "/",
        query: { refresh: "1" },
      });
    },
    // 下拉刷新
    tempOnRefresh() {
      var that = this;
      that.tempRefresh = false;
      that.tempLoading = true;
      that.tempFinished = false;
      that.page = 1;
      that.tempList = [];
      that.requestGetJobListTemp();
    },
    // 上划加载
    tempOnLoad() {
      var that = this;
      that.tempLoading = true;
      that.requestGetJobListTemp();
    },
    // 查询jobList(外包)
    requestGetJobListTemp() {
      var that = this;
      var params = {
        limit: 10,
        page: that.page,
      };
      getTempList(params).then((res) => {
        if (res.data) {
          that.tempRefresh = false;
          that.tempLoading = false;

          that.tempList = that.tempList.concat(res.data.data);

          that.totalPage = res.data.totalPage;
          if (that.page >= that.totalPage) {
            that.tempFinished = true;
          } else {
            that.page++;
          }
        }
      });
    },
    // 临时任务详情
    tempDetail(item) {
        var that = this;
        that.$router.push({
            path: "/tempDetail",
            query: {
              article: item.Slug,
              refresh: "1"
            },
        });
    },
  },
  filters: {
    filterStatus(val) {
      if (val != "" && val != null && val != undefined) {
        if (val == 1) {
          return "进行中";
        } else if (val == 5) {
          return "已结束";
        } else {
          return "";
        }
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.rtd_content {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: #f6f6f6;
  padding: 60px 18.75% 38px 18.75%;

  .rtd_head {
    margin: 88px 0 0 0;
    width: calc(100% - 80px);
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .rtd_title {
      width: calc(100% - 80px);
      height: 40px;
      font-weight: bold;
      font-size: 26px;
      color: #000000;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .rtd_back {
      width: 80px;
      height: 40px;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #000000;

      font-weight: normal;
      font-size: 16px;
      color: #000000;
      line-height: 38px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      cursor: pointer;
    }
  }

  .temp_body {
    margin: 20px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;

    .temp_li {
      width: calc((100% - 60px) / 4);
      height: auto;
      min-height: 158px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #e2e9f6;
      margin: 0 20px 20px 0;
      cursor: pointer;

      .temp_title_salary {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 18px 0 0 0;
        padding: 0 12px 0 12px;

        .temp_title {
          font-weight: bold;
          font-size: 14px;
          color: #2d2d2d;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .temp_salary {
          font-weight: normal;
          font-size: 14px;
          color: #ed754c;
          line-height: 16px;
          text-align: right;
          font-style: normal;
          text-transform: none;
        }
      }

      .temp_titleDesc {
        margin: 17px 0 0 0;
        padding: 0 12px 0 12px;

        width: 100%;
        height: 4.5em;

        font-weight: normal;
        font-size: 12px;
        color: #000000;
        line-height: 1.5em;
        text-align: left;
        font-style: normal;
        text-transform: none;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        white-space: normal;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .temp_status_timeDesc {
        display: flex;
        justify-content: space-between;
        align-items: center;

        width: 100%;
        height: 41px;
        background: #e2e9f6;
        border-radius: 0px 0px 8px 8px;
        padding: 0 12px 0 12px;
        margin: 10px 0 0 0;

        .temp_timeDesc {
          font-weight: normal;
          font-size: 12px;
          color: #5f7192;
          line-height: 14px;
          text-align: right;
          font-style: normal;
          text-transform: none;
        }

        .temp_status1 {
          width: 60px;
          height: 22px;
          background: #43c56f;
          border-radius: 20px 20px 20px 20px;

          font-weight: normal;
          font-size: 12px;
          color: #ffffff;
          line-height: 22px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .temp_status5 {
          width: 60px;
          height: 22px;
          background: #2c8de8;
          border-radius: 20px 20px 20px 20px;

          font-weight: normal;
          font-size: 12px;
          color: #ffffff;
          line-height: 22px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    .temp_li:hover {
      box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
      .temp_title {
        color: rgba(104, 155, 255, 1);
      }
    }

    .temp_li:nth-child(4n) {
      margin: 0 0 20px 0;
    }

    @media screen and (max-width: 1440px) {
      .temp_li {
        width: calc((100% - 40px) / 3);
      }

      .temp_li:nth-child(4n) {
        margin: 0 20px 20px 0;
      }

      .temp_li:nth-child(3n) {
        margin: 0 0 20px 0;
      }
    }

    @media screen and (max-width: 958px) {
      .temp_li {
        width: calc((100% - 20px) / 2);
      }

      .temp_li:nth-child(4n) {
        margin: 0 20px 20px 0;
      }

      .temp_li:nth-child(3n) {
        margin: 0 20px 20px 0;
      }
      .temp_li:nth-child(2n) {
        margin: 0 0 20px 0;
      }
    }

    @media screen and (max-width: 640px) {
      .temp_li {
        width: calc(100%);
      }

      .temp_li:nth-child(4n) {
        margin: 0 20px 20px 0;
      }

      .temp_li:nth-child(3n) {
        margin: 0 20px 20px 0;
      }
      .temp_li:nth-child(2n) {
        margin: 0 20px 20px 0;
      }
      .temp_li:nth-child(1n) {
        margin: 0 0 20px 0;
      }
    }
  }
}

@media screen and (max-width: 958px) {
  .rtd_content {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background: #f6f6f6;
      padding: 60px 4.6875% 0 4.6875%;

    .rtd_head {
      margin: 44px 0 0 0;
      width: calc(100% - 80px);
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .rtd_title {
        width: calc(100% - 80px);
        height: 40px;
        font-weight: bold;
        font-size: 26px;
        color: #000000;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .rtd_back {
        width: 80px;
        height: 40px;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #000000;

        font-weight: normal;
        font-size: 16px;
        color: #000000;
        line-height: 38px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        cursor: pointer;
      }
    }

    .temp_body {
      margin: 20px 0 0 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;

      .temp_li {
        width: calc((100% - 60px) / 4);
        height: auto;
        min-height: 158px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e2e9f6;
        margin: 0 20px 20px 0;
        cursor: pointer;

        .temp_title_salary {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 18px 0 0 0;
          padding: 0 12px 0 12px;

          .temp_title {
            font-weight: bold;
            font-size: 14px;
            color: #2d2d2d;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .temp_salary {
            font-weight: normal;
            font-size: 14px;
            color: #ed754c;
            line-height: 16px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }

        .temp_titleDesc {
          margin: 17px 0 0 0;
          padding: 0 12px 0 12px;

          width: 100%;
          height: 4.5em;

          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 1.5em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          white-space: normal;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .temp_status_timeDesc {
          display: flex;
          justify-content: space-between;
          align-items: center;

          width: 100%;
          height: 41px;
          background: #e2e9f6;
          border-radius: 0px 0px 8px 8px;
          padding: 0 12px 0 12px;
          margin: 10px 0 0 0;

          .temp_timeDesc {
            font-weight: normal;
            font-size: 12px;
            color: #5f7192;
            line-height: 14px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }

          .temp_status1 {
            width: 60px;
            height: 22px;
            background: #43c56f;
            border-radius: 20px 20px 20px 20px;

            font-weight: normal;
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .temp_status5 {
            width: 60px;
            height: 22px;
            background: #2c8de8;
            border-radius: 20px 20px 20px 20px;

            font-weight: normal;
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }

      .temp_li:hover {
        box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
        .temp_title {
          color: rgba(104, 155, 255, 1);
        }
      }

      .temp_li:nth-child(4n) {
        margin: 0 0 20px 0;
      }

      @media screen and (max-width: 1440px) {
        .temp_li {
          width: calc((100% - 40px) / 3);
        }

        .temp_li:nth-child(4n) {
          margin: 0 20px 20px 0;
        }

        .temp_li:nth-child(3n) {
          margin: 0 0 20px 0;
        }
      }

      @media screen and (max-width: 958px) {
        .temp_li {
          width: calc((100% - 20px) / 2);
        }

        .temp_li:nth-child(4n) {
          margin: 0 20px 20px 0;
        }

        .temp_li:nth-child(3n) {
          margin: 0 20px 20px 0;
        }
        .temp_li:nth-child(2n) {
          margin: 0 0 20px 0;
        }
      }

      @media screen and (max-width: 640px) {
        .temp_li {
          width: calc(100%);
        }

        .temp_li:nth-child(4n) {
          margin: 0 20px 20px 0;
        }

        .temp_li:nth-child(3n) {
          margin: 0 20px 20px 0;
        }
        .temp_li:nth-child(2n) {
          margin: 0 20px 20px 0;
        }
        .temp_li:nth-child(1n) {
          margin: 0 0 20px 0;
        }
      }
    }
  }
}
</style>